import { useState } from "react";
import { Dropdown } from "react-bootstrap";
import IconResource from "../../Wrapper/IconResource/IconResource";
import Button from "../_widgets/Button/Button";
import Input from "../_widgets/Input/Input";

const WhatsAppInboxChatPanel = ({ selectedChat, onBack, onToggleDetails, isMobileView }) => {
  const [message, setMessage] = useState("");
  const [activeTab, setActiveTab] = useState("Reply");

  const messages = [
    {
      id: 1,
      text: "hello",
      time: "08 Oct, 12:00 pm",
      sender: "user",
      status: "read",
    },
    {
      id: 2,
      text: "Cc",
      time: "08 Oct, 12:01 pm",
      sender: "contact",
      status: "sent",
    },
  ];

  const handleSend = () => {
    if (message.trim()) {
      setMessage("");
    }
  };

  return (
    <div className="chat_area_container">
      {/* Chat Header */}
      <div className="chat_area_header">
        <div className="chat_header_left">
          {isMobileView && (
            <button className="chat_back_button" onClick={onBack}>
              <IconResource type="leftArrow" />
            </button>
          )}
          {/* <div className="chat_user_avatar_small">{selectedChat?.initials}</div> */}
          <div className="chat_user_details">
            <h6 className="chat_username">{selectedChat?.name}</h6>
            <a href="#" className="chat_label_link">
              Add label to conversation
            </a>
          </div>
        </div>

        <div className="chat_header_right">
          <Dropdown className="chat_assign_dropdown">
            <Dropdown.Toggle className="chat_assign_btn">
              <IconResource type="user" size={16} />
              <IconResource type="angleDown" size={16} />
            </Dropdown.Toggle>
            <Dropdown.Menu align="end">
              <Dropdown.Item>
                <IconResource type="user" size={16} /> Yourself ✓
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>

          {!isMobileView ? (
            <Button buttonType="primary" text="  Close chat" onClick={onToggleDetails} />
          ) : (
            <Button
              buttonType="button"
              icon={<IconResource type="dotsVertical" size={18} className="" />}
              onClick={onToggleDetails}
            />
          )}
        </div>
      </div>

      {/* Chat Messages */}
      <div className="chat_messages_area">
        <div className="chat_system_notification">
          You assigned this conversation to yourself 2 minutes ago
        </div>

        {messages.map((msg) => (
          <div key={msg.id} className={`chat_message_row ${msg.sender}`}>
            {msg.sender === "user" ? (
              <>
                <div className="chat_message_avatar">{selectedChat?.initials}</div>
                <div>
                  <div className="d-flex align-item-center justify-content-end">
                    <button className="chat_reply_btn">
                      <IconResource type="fillArrowBack" />
                    </button>
                    <div className="chat_message_bubble user_bubble">
                      <p className="chat_bubble_text">{msg.text}</p>
                    </div>
                  </div>
                  <span className="chat_message_time">
                    {msg.time}{" "}
                    {msg.status === "read" && (
                      <IconResource type="dubleCheckmark" className="message_read_check" />
                    )}
                  </span>
                </div>
              </>
            ) : (
              <>
                <div className="chat_message_avatar">{selectedChat?.initials}</div>
                <div>
                  <div className="d-flex align-item-center">
                    <div className="chat_message_bubble contact_bubble">
                      <p className="chat_bubble_text">{msg.text}</p>
                    </div>
                    <button className="chat_reply_btn">
                      <IconResource type="fillArrowBack" />
                    </button>
                  </div>
                  <span className="chat_message_time">
                    {msg.time} {msg.status === "read" && "✓✓"}
                  </span>
                </div>
              </>
            )}
          </div>
        ))}

        <div className="chat_system_notification">This chat was closed by you a minute ago</div>

        <div className="chat_message_row contact">
          <div className="chat_message_avatar">{selectedChat?.initials}</div>
          <div>
            <div className="d-flex align-item-center">
              <div className="chat_message_bubble contact_bubble">
                <p className="chat_bubble_text">sds</p>
              </div>
              <button className="chat_reply_btn">
                <IconResource type="fillArrowBack" />
              </button>
            </div>
            <span className="chat_message_time">08 Oct, 12:01 pm</span>
          </div>
        </div>

        <div className="chat_system_notification">
          This chat was opened by customer a minute ago
        </div>
      </div>

      {/* Chat Input */}
      <div className="chat_input_container">
        <div className="chat_input_wrapper">
          <div className="chat_tabs_tools_wrap">
            <div className="chat_input_tabs_row">
              <button
                className={`chat_tab_button ${activeTab === "Reply" ? "active" : ""}`}
                onClick={() => setActiveTab("Reply")}
              >
                Reply
              </button>
              <button
                className={`chat_tab_button ${activeTab === "Notes" ? "active" : ""}`}
                onClick={() => setActiveTab("Notes")}
              >
                Notes
              </button>
            </div>

            <div className="chat_toolbar_row">
              <button className="chat_toolbar_button">
                <IconResource type="outlineDollar" />
              </button>
              <button className="chat_toolbar_button">
                <IconResource type="Storefront" />
              </button>
              <button className="chat_toolbar_button">
                <IconResource type="listBullet" />
              </button>
              <button className="chat_toolbar_button">
                <IconResource type="messageRounded" />
              </button>
              <button className="chat_toolbar_button">
                <IconResource type="fileAttachment" />
              </button>
              <button className="chat_toolbar_button">
                <IconResource type="fileTemplate" />
              </button>
              <button className="chat_toolbar_button">
                <IconResource type="laughingEmoji" />
              </button>
            </div>
          </div>
          <div className="chat_message_input">
            <Input
              type="text"
              placeholder="Reply"
              as="textarea"
              rows={3}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />
          </div>
        </div>
        <div className="chat_send_button_wrap">
          {!isMobileView ? (
            <Button buttonType="primary" text="Send" className="web_button" />
          ) : (
            <Button
              buttonType="primary"
              prefixIcon={<IconResource type="sendIcon" size={18} />}
              className="mobile_button"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default WhatsAppInboxChatPanel;
